import React, { useEffect, useState } from "react";
import '../../../CSS/Areas.css'
import {BsPlus} from "react-icons/bs";
import {getPermission} from '../../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import { FaArrowLeftLong } from "react-icons/fa6";
import { deleteApi, getApi, postApi } from "../../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningModal, warningToast } from "../../../Utils/AlertMessage";
import { Button, CloseButton, Modal } from "react-bootstrap";
import Loading from '../../../Utils/Loading';

function ObrasUsuarios(){
    const navigate = useNavigate();
    const [obrasRoles, setObrasRoles] = useState([]);
    const [tablaRoles, setTablaRoles] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'obras-usuarios/';
    const [isLoading,setIsLoading]=useState(false);

    useEffect(()=>{
        const getObrasRoles = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,6);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setObrasRoles(res.data);
                        setTablaRoles(res.data);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getObrasRoles();
    },[idUsuario,navigate])

    const getObrasRoles = async () =>{
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setObrasRoles(res.data)
                setTablaRoles(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaRoles.filter((elemento)=> {
            if  (elemento.nombreObra.toString().toLowerCase().includes(texto.toLowerCase()) || 
                elemento.nombreEmp.toString().toLowerCase().includes(texto.toLowerCase())
            ){  
                return elemento;
            }
            return resBusqueda;
        })
        setObrasRoles(resBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos');
    }

    const modalDelete = (id,idU) => {
        warningModal('¿QUIERES ELIMINAR ESTE REGISTRO?')
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id + '/'+idU;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="¡REGISTRO ELIMINADO CORRECTAMENTE!"){
                        getObrasRoles();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    const [obras, setObras] = useState([]);
    const [usuarios, setUsuarios] = useState([])
    const [obra, setObra] = useState('');
    const [user, setUser] = useState('');
    const [isSaving, setSaving] = useState(false);

    const getObrasUsuarios = async () => {
        const endpoint = 'obrasusuarios/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setObras(res.data[0].obras);
                setUsuarios(res.data[0].usuarios);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const showAdd = async () => {
        await getObrasUsuarios();
        handleShow();
    }
    const closeAdd = () =>{
        handleClose();
        setObra('');
        setUser('');
    }
    const store = async (e) =>{
        setSaving(true);
        e.preventDefault();
        if(obra === '' || usuario === ''){
            warningToast('CAMPOS VACIOS','EL CAMPO OBRA O USUARIO ESTA VACÍO');
        }else{
            const endpoint = uri;
            const data = {idObra:obra, idUsuario:user};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    closeAdd();
                    getObrasRoles();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }
     
    return(
        <div className="areas">
            {
                isLoading ?
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">GESTIÓN DE OBRAS Y USUARIOS</label>
                    </div>
                    <div className='divbotonA' >
                        <div className='botonA' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={showAdd} type="button">
                                <label className="agregar">AGREGAR</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>                    
                        </div>
                    </div>
                    {
                        obrasRoles.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA" >
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered text-uppercase">
                                        <thead className="encabezado">
                                            <tr >                                
                                                <th>OBRA</th>
                                                <th>USUARIO</th>
                                                <th>ROL</th>
                                                <th style={{width:'20%'}}>ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {obrasRoles.map((o, id) =>{
                                                return(                                    
                                                    <tr key={id}>                                       
                                                        <td valign="middle">{o.nombreObra}</td>
                                                        <td valign="middle">{o.nombreEmp+' '+o.apellidoPaternoEmp+' '+o.apellidoMaternoEmp}</td>
                                                        <td valign="middle">{o.nombreRol}</td>
                                                        <td>
                                                            <div>
                                                                <div className="btn iconoH" style={{margin:'5px'}} >
                                                                    <span className="bi bi-trash" title="ELIMINAR" onClick={() => modalDelete(o.idObra,o.idUsuario)}></span>
                                                                </div>                                     
                                                            </div>
                                                        </td>                                                                                                
                                                    </tr>                                                                        
                                                )
                                            })}                        
                                        </tbody>
                                    </table>
                                </div>      
                            </div>
                        )
                    }

                    {/*AGREGAR OBRA-USUARIO*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-obraUsuario">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR USUARIO A OBRA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={closeAdd} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', }}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">OBRA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control" required 
                                    onChange={e => setObra(e.target.value) }   >
                                        <option value={''}>--Seleccione una opción--</option>
                                        {obras.map(o => {
                                            return(
                                                <option key={o.idObra} value={o.idObra}>{o.nombreObra}</option>
                                            )
                                        })
                                        }                                
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">USUARIO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control" required 
                                    onChange={e => setUser(e.target.value) }   >
                                        <option value={''}>--Seleccione una opción--</option>
                                        {usuarios.map(u => {
                                            return(
                                                u.idEmpleado === idUsuario ? (null):
                                                <option key={u.idEmpleado} value={u.idEmpleado}>{u.nombreEmp+' '+u.apellidoPaternoEmp+' '+u.apellidoMaternoEmp}</option>
                                            )
                                        })
                                        }                                
                                    </select>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={closeAdd}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default ObrasUsuarios;